/** ISO 3166-1 alpha-2 codes keyed by magnet hub / country bonus id. Regions (e.g. africa) have no code. */
export const COUNTRY_CODES = {
  bangladesh: 'BD',
  india: 'IN',
  nepal: 'NP',
  pakistan: 'PK',
  nigeria: 'NG',
  kenya: 'KE',
  cameroon: 'CM',
  ethiopia: 'ET',
  ghana: 'GH',
  philippines: 'PH',
  tanzania: 'TZ',
  uganda: 'UG',
  'south-africa': 'ZA',
  zambia: 'ZM',
};
